'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: 'calc(100% - 48px)',
        maxWidth: '680px',
        background: 'rgba(18, 18, 20, 0.97)',
        border: '1px solid rgba(63,63,70,0.7)',
        borderRadius: '14px',
        padding: '20px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
        {/* Cookie icon */}
        <div style={{ flexShrink: 0, marginTop: '2px' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(250,204,21,0.85)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"/>
            <circle cx="12" cy="12" r="1" fill="rgba(250,204,21,0.85)" stroke="none"/>
            <circle cx="8" cy="14" r="1" fill="rgba(250,204,21,0.85)" stroke="none"/>
            <circle cx="15" cy="9" r="1" fill="rgba(250,204,21,0.85)" stroke="none"/>
          </svg>
        </div>
        <div>
          <p style={{ color: 'var(--white)', fontSize: '14px', fontWeight: 600, fontFamily: 'DM Sans, sans-serif', marginBottom: '6px' }}>
            Folosim cookie-uri
          </p>
          <p style={{ color: 'var(--aluminum-dim)', fontSize: '13px', fontFamily: 'DM Sans, sans-serif', lineHeight: '1.6' }}>
            Utilizăm cookie-uri esențiale pentru funcționarea site-ului și cookie-uri analitice pentru a înțelege cum este utilizat. Prin acceptare, ești de acord cu{' '}
            <Link href="/confidentialitate" style={{ color: 'rgba(96,165,250,0.9)', textDecoration: 'underline' }}>
              Politica de Confidențialitate
            </Link>
            .
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <button
          onClick={handleDecline}
          style={{
            padding: '8px 18px',
            borderRadius: '8px',
            border: '1px solid rgba(63,63,70,0.8)',
            background: 'transparent',
            color: 'var(--aluminum-dim)',
            fontSize: '13px',
            fontWeight: 500,
            fontFamily: 'DM Sans, sans-serif',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'rgba(100,100,110,1)';
            e.currentTarget.style.color = 'var(--white)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(63,63,70,0.8)';
            e.currentTarget.style.color = 'var(--aluminum-dim)';
          }}
        >
          Refuz
        </button>
        <button
          onClick={handleAccept}
          style={{
            padding: '8px 22px',
            borderRadius: '8px',
            border: 'none',
            background: 'var(--white)',
            color: '#0a0a0b',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: 'DM Sans, sans-serif',
            cursor: 'pointer',
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.88')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
          Accept toate
        </button>
      </div>
    </div>
  );
}
